<template lang="pug">
  div(id="app")
    div(id="headerDiv" ref='headerDiv')
      div(id="headerDiv__inner" ref='headerDiv__inner')
        img( src="./assets/uprightlogo.png" alt="Upright Realty Group LLC, Boston MA" ref='logo' )
        address( ref='address' )
          ul
            li: span 1128 Commonwealth Ave
            li: span Boston, MA 02134
            li: span(class='el-icon-phone')  (617) 505-6868
    div(id="navMenuDiv")
      ul(class='wideMenu')
        li: router-link( to="/home") Home
        li: router-link( to="/listings") Rentals
        li: router-link( to="/sales") Sales
        li: router-link( to="/agents") Agents
        li: router-link( to="/contact") Contact Us
      //- ul(class='collapsedMenu')
      //-   li: router-link( to="/listings") Rentals
      //-   li: router-link( to="/contact") Contact Us
    div(id='routerDiv')
      keep-alive
        router-view(
          @update:active-listing="setActiveListing"
        )
      
    ListingDetailsView(
      v-if='listingDetailsDialogVisible && activeListing'
      v-bind:listing='activeListing'
      v-bind:visible.sync='listingDetailsDialogVisible'
      v-bind:listingArray='activeListingArray'
      @update:active-listing="setActiveListing"
    )
    ListingFavoritesTracker( @update:active-listing="setActiveListing" )
    div( class='page-footer')
      img( class="left" src="./assets/uprightlogo.png" alt="Upright Realty Group LLC, Boston MA" )
      div( id="footer__navigation-div" )
        ul
          li(class="header") Navigation
          li: router-link( to="/home") Home
          li: router-link( to="/listings") Rentals
          li: router-link( to="/sales") Sales
          li: router-link( to="/contact") Contact Us
          li(v-if='!admin'): <GoogleLogin :params="googleParams" :onSuccess="googleOnSuccess" :onFailure="googleOnFailure">Login</GoogleLogin>
          li(v-if='admin'): <a @click='logout'>Logout</a>
      div( class="copyright-notice") &copy; 2019 Upright Realty Group LLC, All Rights Reserved
      img( class="right" src="./assets/equal-housing-opportunity-logo-white-png.png" alt="Equal Housing Opportunity Logo" )
</template>

<script>
import ListingDetailsView from './components/ListingDetailsView'
import ListingFavoritesTracker from './components/ListingFavoritesTracker'
//import ListingSearchPage from './components/ListingSearchPage'
import {GOOGLE_HOME_MAPSTRING, GOOGLE_MAPS_URL, AUTHENTICATE_URL/*, LISTINGS_URL*/} from './components/settings'
//import {renderButton} from "./GoogleSignIn.js"
import GoogleLogin from 'vue-google-login'
const axios = require('axios')
//const CancelToken = axios.CancelToken;

export default {
  name: 'app',
  components: {
    ListingDetailsView,
    ListingFavoritesTracker,
    GoogleLogin
    //ListingSearchPage
  },
  data(){
    return {
      activeListing: null,
      activeListingArray: [],
      listingDetailsDialogVisible: false,
      mapLocationString: GOOGLE_HOME_MAPSTRING,
      googleParams: {
        client_id: "448746096656-qhpqcsdvj1v3hui9jmkg7dgq75gspbgb.apps.googleusercontent.com"
      }
    }
  },
  computed: {
    mapURL() {return GOOGLE_MAPS_URL + "&q=" + this.mapLocationString},
    
    admin: {
      get(){ return this.$store.state.admin },
      set(value){ this.$store.commit('updateAdmin', value) }
    }
  },
  methods: {
    setActiveListing({listing, listings}){
      //alert(JSON.stringify(listing));
      this.activeListing = listing;
      this.activeListingArray = listings ? listings : [];
      this.mapLocationString = [listing.StreetNumber, listing.StreetName, listing.City, "MA"].join("+");
      this.listingDetailsDialogVisible = true;
    },

    async googleOnSuccess(googleUser){
      const id_token = googleUser.getAuthResponse().id_token;
      try{
        await axios.get(AUTHENTICATE_URL , {
          params: {
            token: id_token
          }
        })
        this.admin = googleUser.getBasicProfile().getEmail();
      }
      catch{
        this.googleOnFailure();
      }
    },

    googleOnFailure(){
      this.admin = false;
      alert("Only Upright Realty agents may log in.");
    },

    async logout(){
      try{
        await axios.get(AUTHENTICATE_URL + "/logout")
        this.admin = false;
      }
      catch(e){
        alert(e);
      }
    }
  },

  mounted(){
    if(!(typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1)){
      setInterval(() => {
        if (window.pageYOffset < 400)
          window.requestAnimationFrame( () => {
            this.$refs['logo'].style.transform = 'translateY(+' + Math.round(window.pageYOffset/2) + 'px)';
            this.$refs['address'].style.opacity = (window.pageYOffset < 100 ) ? 1-(window.pageYOffset/100) : 0;
            //this.$refs.headerDiv.style.backgroundPosition = '0 -' + (window.pageYOffset/3.5) + 'px';
            
          });
      }, 10)
    }
  }
}

</script>

<style lang="scss">
//@import './sass-variables';
a{
  cursor: pointer;
}

#app {
  font-family: Rubik, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $color-text-primary;
}

#routerDiv{
  background-color: $color-background;
}

#headerDiv{
  background-repeat: no-repeat;
  background-position: center right;
  background-size: cover;
  height: 400px;
  text-align: left;
  border: 1px solid $color-accent;
  border-bottom: 10px solid $color-accent;
  box-shadow: 1px 1px 3px rgb(44, 44, 44);
  background-image: url('assets/bostonblue1600x640.jpg');

  background-color: mix(black,$color-primary, 40);
  margin-bottom: 3px;
  //box-shadow: 0 0 10px $color-accent;
  //background-blend-mode: hue;

}

// #headerDiv::after{
//   content: " ";
//   position: absolute;
//   top: 0;
//   right: 0;
//   bottom: 0;
//   left:0;
//   transform: translateZ(-1px) scale(2) translateX(-4px) translateY(-70px);
//   //background-size: 100%;
//   z-index: -1;
//   background-image: url('assets/bostonblue1000x400.jpg');
//   background-size: cover;
//   background-position: center center;
//   overflow: hidden;
//   height: 450px;
// }
 

#headerDiv img{
  position: absolute;
  max-width: 100vw;
}

html, body{
  background-color: $color-background;
  margin: 0;
  color: #444444;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  word-wrap: normal;
}

#navMenuDiv{
  color: white;
  font-weight: bold;
  font-size: 1.3em;
  position: absolute;
  top: 350px;
  //left: 19px;
  right: 20px;
}

#navMenuDiv ul{
  list-style-type: none;
  display: flex;
  justify-content: flex-left;
  position: relative;
}

#navMenuDiv li{
  margin-right: 8px;
  //background-color: rgba(0, 0, 0, .7);
  
}

#navMenuDiv li.router-link-active{
  border: 1px solid $color-accent;
}

#navMenuDiv li a.router-link-active{
  color: mix(white, $color-accent, 10);
  border: 1px solid $color-accent;
}

#navMenuDiv li a:hover{
  border: 1px solid $color-accent;
  cursor: pointer;
} 

#navMenuDiv li a{
  border-radius: 3px;
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, 0);
}

h2{
  text-align: center;
  color: rgb(255, 255, 255);
  /* background-color: rgb(36, 36, 88); */
  background-color: $color-primary;
  margin: 0;
  padding: 0;
  margin-top: 5px;
}

.page-footer{
  margin-top: 20px;
  height: 175px;
  color: white;
  padding-top: 20px;
  position: relative;
  border-top: 10px solid $color-accent;
  background: linear-gradient(0deg, mix(black, $color-primary, 50) 0%, mix(black, $color-primary, 80) 100%);
}

.page-footer img.left{
  opacity: .9;
  position: absolute;
  height: 50%;
  left: 0;
}

.page-footer img.right{
  opacity: .85;
  position: absolute;
  height: 40%;
  right: 20px;
  top: 40px;
}

.copyright-notice{
  position: absolute;
  bottom: 10px;
  color: white;
  opacity: .4;
  text-align: center;
  width: 100%;
  font-size: .8em;
}

.page-footer ul, .page-footer li{
  text-align: left;
}

.page-footer li{
  font-weight:normal;
  font-size: .9em;
  opacity: .8;
  margin-bottom: 5px;
}

.page-footer .header{
  font-weight: bold;
  font-size: 1.2em;
  margin-bottom: 10px;
  //text-shadow: 0 0 2px $color-accent;
}

#footer__navigation-div{
  margin-left: 280px;
}


a{
  color: white;
  text-decoration: none;
}

address{
  color: white;
  text-align: right;
  font-style: normal;
}

ul{
  list-style-type: none;
  margin: 0;
  padding: 0;
}

#headerDiv address{
  position: absolute;
  right: 50px;
  top: 30px;
  font-size: 1.1em;
}

#headerDiv{
  overflow: hidden;
}

.el-icon-phone{
  margin-top: 10px;
  color: $color-accent;
}

// #navMenuDiv .collapsedMenu{
//   display: none;
// }

@media screen and (max-width: 660px) {
  address{
    text-align: center;
  }
  
  #headerDiv address{
    width: 100vw;
    text-emphasis: center;
    top: 200px;
    right: 0;
    margin: 0;
    padding: 0;
  }

  // #navMenuDiv .collapsedMenu{
  //   display: inherit;
  // }

  // #navMenuDiv .wideMenu{
  //   display: none;
  // }

  #navMenuDiv{
    right: 0;
    // width: 100vw;
    top: 300px;
  }

  #navMenuDiv ul{
    right: 0;
    // justify-content: center;
    // width: 100vw;
    // margin-left: 5%;
    text-align: center;
    padding: 20px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    min-width: 0;
  }

  #navMenuDiv a{
    margin: 0;
    padding: 0;
  }

  #navMenuDiv li{
    margin: 0;
    margin-bottom: 15px;
    white-space: nowrap;
  }

  #headerDiv img{
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
  }

  #navMenuDiv li a{
    padding: 5px 10px;
  }
}

@media screen and (max-width: 434px) {
  #headerDiv img{
    width: 90vw;
  }

  #navMenuDiv ul, span{
    font-size: .7em;
  }

  .page-footer .right{
    display: none;
  }
}



::-webkit-scrollbar {
  width: 6px;
  cursor: pointer;
}


::-webkit-scrollbar-track {
  background: $color-background;
  border-radius: 3px;
  box-shadow: inset 0 0 3px black;
  cursor: pointer;
}

::-webkit-scrollbar-thumb {
  background: $color-accent; 
  border-radius: 3px;
  cursor: pointer;
}


</style>
